// extracted by mini-css-extract-plugin
module.exports = {"input":"Input__input___3e_bf","inputLabel":"Input__inputLabel___3VF0S","label":"Input__label___23sO8","radio":"Input__radio___2hllK"};